'use client';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Image from 'next/image';

interface SquareCardProps {
  image: string;
  title: string;
  description: string;
}

export default function SquareCard({ image, title, description }: SquareCardProps) {
  return (
    <Stack direction='column' sx={{ alignItems: 'center', justifyContent: 'center' }}>
      {/* Background Image */}
      <Box
        sx={{
          position: 'relative',
          width: '60%',
          aspectRatio: '1/1',
          overflow: 'hidden',
          borderRadius: '10px',
          '& img': {
            transition: 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
          },
          '&:hover img': {
            transform: 'scale(1.06)',
          },
          '@media (prefers-reduced-motion: reduce)': {
            '& img': { transition: 'none' },
            '&:hover img': { transform: 'none' },
          },
        }}
      >
        {image && (
          <Image
            src={image}
            alt={title}
            fill
            sizes='(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 33vw'
            style={{ objectFit: 'cover', borderRadius: 10 }}
          />
        )}
      </Box>

      <Typography
        variant='body1'
        sx={{
          color: 'text.primary',
          fontWeight: 'bold',
          lineHeight: 1.2,
          textAlign: 'center',
        }}
      >
        {title}
      </Typography>
      <Typography
        variant='body2'
        sx={{
          color: 'text.secondary',
          lineHeight: 1.4,
          textAlign: 'center',
        }}
      >
        {description}
      </Typography>
    </Stack>
  );
}
